<template>
  <div class="l-toast-section" id="l-toast" v-if="isShow">
    {{ msg }}
  </div>
</template>

<script>
export default {
  name: "l-toast",
  data () {
    return {
      msg: '',
      isShow: false
    }
  }
}
</script>

<style lang="stylus" scoped>
.l-toast-section
  width 100%
  position fixed
  bottom 0
  left 0
  height 91px
  line-height 91px
  text-align center
  background rgba(0, 0, 0, 0.78)
  font-size 19px
  color #fff700
  z-index 2000
</style>
